import './friendRequestActionPage.css';
import React, {Component} from "react";
import {Navigate} from "react-router-dom";
import FriendService from "../services/friendService";
import {ToastErrorLevel} from "../../App";
import {withRouter} from "./withRouter";
import LoadingSpinner from "./loadingSpinner";
import i18nService from "../../i18n/i18nService";

interface FriendRequestActionPageState {
    navigation?: string,
    isLoading: boolean,
    message?: string,
    error?: string,
}

interface FriendRequestActionPageProps {
    toastGenerator: (body: string, level: ToastErrorLevel) => any,
    action: "accept" | "reject",
}

class FriendRequestActionPage extends Component<FriendRequestActionPageProps, FriendRequestActionPageState> {
    constructor(props: FriendRequestActionPageProps) {
        super(props, {});
        this.state = {
            isLoading: true,
        };
    }

    async componentDidMount() {
        // @ts-ignore
        const params = new URLSearchParams(this.props.location?.search || window.location.search);
        const requestId = params.get("requestId");

        if (!requestId) {
            this.setState({
                error: "Invalid friend request link",
                isLoading: false,
                navigation: "/profile",
            });
            this.props.toastGenerator("Invalid friend request link", ToastErrorLevel.ERROR);
            return;
        }

        if (this.props.action === "accept") {
            await FriendService.acceptFriendRequest(
                {requestId},
                async () => {
                    this.props.toastGenerator("Friend request accepted!", ToastErrorLevel.INFO);
                    this.setState({
                        message: "Friend request accepted!",
                        isLoading: false,
                        navigation: "/profile",
                    });
                },
                async (error: string) => {
                    this.props.toastGenerator(error, ToastErrorLevel.ERROR);
                    this.setState({
                        error: error,
                        isLoading: false,
                        navigation: "/profile",
                    });
                },
                async (url: string) => {
                    this.setState({navigation: url});
                }
            );
        } else {
            await FriendService.rejectFriendRequest(
                {requestId},
                async () => {
                    this.props.toastGenerator("Friend request rejected.", ToastErrorLevel.INFO);
                    this.setState({
                        message: "Friend request rejected.",
                        isLoading: false,
                        navigation: "/profile",
                    });
                },
                async (error: string) => {
                    this.props.toastGenerator(error, ToastErrorLevel.ERROR);
                    this.setState({
                        error: error,
                        isLoading: false,
                        navigation: "/profile",
                    });
                },
                async (url: string) => {
                    this.setState({navigation: url});
                }
            );
        }
    }

    render() {
        if (this.state.navigation) {
            return <Navigate to={this.state.navigation} />;
        }

        return (
            <div className="FriendRequestActionPage-Wrapper">
                <div className="FriendRequestActionPage-Container">
                    {this.state.isLoading ? (
                        <div className="FriendRequestActionPage-Loading">
                            <LoadingSpinner size="large" message={i18nService.t('friends.processing', 'Processing...')} />
                        </div>
                    ) : this.state.error ? (
                        <div className="FriendRequestActionPage-Error">{this.state.error}</div>
                    ) : (
                        <div className="FriendRequestActionPage-Success">{this.state.message}</div>
                    )}
                </div>
            </div>
        );
    }
}

export default withRouter(FriendRequestActionPage);

